module.exports = __webpack_public_path__ + "img/right-1.a22e45ea.png";